<template>
    <button class="btn btn-primary" type="submit" :disabled="pending || $attrs.disabled">
        <template v-if="pending">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ pendingText }}
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </button>
</template>

<script>
export default {
    props: {
        pending: {
            type: Boolean,
            default: false
        },
        pendingText: {
            type: String
        }
    }
}
</script>

<style lang="scss" scoped>
    .spinner-border-sm {
        width: 15px;
        height: 15px;
    }
</style>
